import { useEffect, useState } from 'react';
import { DocumentIcon, ArrowDownTrayIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import axios from '../../axios';

// Descarga bajo demanda el binario multimedia vía proxy autenticado (el src no puede apuntar
// directo al endpoint porque el navegador no envía el header Authorization en <img>/<audio>).
const MediaMessage = ({ logId, mediaType, caption, filename }) => {
    const [blobUrl, setBlobUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let objectUrl = null;
        let cancelado = false;

        const cargarMedia = async () => {
            setLoading(true);
            setError(false);
            try {
                const response = await axios.get(`api/whatsapp/logs/${logId}/media`, {
                    responseType: 'blob',
                });
                objectUrl = URL.createObjectURL(response.data);
                if (!cancelado) setBlobUrl(objectUrl);
            } catch (err) {
                console.error('Error al cargar multimedia:', err);
                if (!cancelado) setError(true);
            } finally {
                if (!cancelado) setLoading(false);
            }
        };

        cargarMedia();

        return () => {
            cancelado = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [logId]);

    if (loading) {
        return (
            <div className="flex items-center gap-2 py-1 px-0.5 text-xs text-gray-500">
                <div className="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-[#25D366]"></div>
                Cargando {mediaType === 'audio' ? 'audio' : mediaType === 'image' ? 'imagen' : 'archivo'}...
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center gap-1.5 py-1 px-0.5 text-xs text-red-500">
                <ExclamationTriangleIcon className="h-4 w-4 shrink-0" />
                Archivo ya no disponible (expiró en WhatsApp)
            </div>
        );
    }

    return (
        <div className="space-y-1">
            {mediaType === 'audio' && (
                <audio controls src={blobUrl} className="max-w-60 h-10" />
            )}

            {(mediaType === 'image' || mediaType === 'sticker') && (
                <a href={blobUrl} target="_blank" rel="noopener noreferrer">
                    <img src={blobUrl} alt="Imagen enviada" className="max-w-60 rounded-lg cursor-zoom-in" />
                </a>
            )}

            {mediaType === 'video' && (
                <video controls src={blobUrl} className="max-w-60 rounded-lg" />
            )}

            {mediaType === 'document' && (
                <a
                    href={blobUrl}
                    download={filename || 'documento'}
                    className="flex items-center gap-2 bg-gray-50 hover:bg-gray-100 rounded-lg px-3 py-2 border border-gray-200 transition-colors"
                >
                    <DocumentIcon className="h-6 w-6 text-gray-500 shrink-0" />
                    <span className="text-sm text-gray-700 truncate flex-1">{filename || 'Documento'}</span>
                    <ArrowDownTrayIcon className="h-4 w-4 text-gray-500 shrink-0" />
                </a>
            )}

            {caption && (
                <p className="text-sm text-gray-900 whitespace-pre-wrap wrap-break-word">{caption}</p>
            )}
        </div>
    );
};

export default MediaMessage;
